import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { fetchVariants } from './SubscriptionListingPage.duck';
import { FormattedMessage } from 'react-intl';
import css from './ListingPage.css';
import { NamedLink } from '../../components';
import classNames from 'classnames';

const SectionVariantsMaybe = ({ productCategory, listingId, providerId, point, providerName, onOpenSizesModal }) => {
  const dispatch = useDispatch();

  const [payload, setPayload] = useState(null); // { data, included }
  const [loading, setLoading] = useState(false);
  const [otherStoresExpanded, setOtherStoresExpanded] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      if (!listingId || !point) return;
      setLoading(true);
      setErr(null);

      try {
        const action = await dispatch(fetchVariants(listingId, point));
        if (!cancelled) setPayload(action?.data || null);
      } catch (e) {
        if (!cancelled) setErr('Nie udało się pobrać wariantów');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, [listingId, point]);

  const variants = useMemo(() => {
    if (!payload) return [];
    const data = Array.isArray(payload.data) ? payload.data : [];
    const included = Array.isArray(payload.included) ? payload.included : [];

    return data.map(it => {
      const cid = it?.relationships?.catalogItem?.data?.id.uuid;
      if (!cid) return null;
      const catalogItem = included.find(inc => inc?.type === 'catalog-item' && inc?.id.uuid === cid);
      const label = catalogItem?.attributes?.shortTitle || '—';

      const provider = included.find(inc => inc?.type === 'provider' && inc?.id.uuid === it?.relationships?.provider?.data?.id.uuid);

      return {
        id: it.id,
        label,
        listingId: it.id.uuid,
        index: catalogItem.attributes?.index || 0,
        providerId: it?.relationships?.provider?.data?.id.uuid,
        providerName: provider?.attributes?.name || null
      };
    }).filter(it => it !== null && it.index);
  }, [payload]);

  const otherProviderGroups = useMemo(() => {
    const groups = variants
      .filter(v => v.providerId && v.providerId !== providerId)
      .reduce((acc, v) => {
        if (!acc[v.providerId]) {
          acc[v.providerId] = {
            providerId: v.providerId,
            providerName: v.providerName || 'Inny sklep',
            items: [],
          };
        }
        acc[v.providerId].items.push(v);
        return acc;
      }, {});

    // sortowanie: grupy po nazwie, itemy po index
    return Object.values(groups)
      .map(g => ({
        ...g,
        items: g.items.sort((a, b) => a.index - b.index),
      }))
      .sort((a, b) => a.providerName.localeCompare(b.providerName));
  }, [variants, providerId]);

  if (variants.length <= 1) return null;

  return (
    <div className={css.sectionDescription}>
      <div className={css.sizeHeader}>
        <h2 className={css.descriptionTitle}>
          <FormattedMessage id="ListingPage.variantsTitle" defaultMessage="Rozmiary" />
        </h2>
        {
          (productCategory === 'wintersports_alpineskiing' || productCategory === 'wintersports_snowboard' || productCategory === 'wintersports_seasonalski' || productCategory === 'wintersports_crosscountry') ?
          <a className={css.chooseSize} id="chooseSizeLink" onClick={onOpenSizesModal}>
            <FormattedMessage id="ListingPage.chooseSize" defaultMessage="Jak wybrać rozmiar?" />
          </a> : null
        }
      </div>

      {err && <div className={css.variantsError}>{err}</div>}

      {!loading && !err && (
        <div>
          <h3 className={css.variantProviderHeading}>
            {providerName}
          </h3>
          <div className={css.variantsGrid} role="list">
            {
              variants.filter(v => v.providerId === providerId).sort((a, b) => a.index - b.index).map(v => (
                <NamedLink
                  id="variantLink"
                  name="ListingPageCanonical"
                  params={{ id: v.listingId }}
                  key={v.id}
                  className={classNames(css.variantItem, { [css.active]: v.listingId === listingId })}
                >
                  {v.label}
                </NamedLink>
              ))
            }
          </div>
          {/* {
            !otherStoresExpanded && otherProviderGroups.length > 0 && <a onClick={() => setOtherStoresExpanded(true)}>Ten produkt znajdziesz w innych sklepach w okolicy</a>
          } */}
          {otherProviderGroups.map(group => (
            <section key={group.providerId} className={css.providerBlock}>
              <h3 className={css.variantProviderHeading}>
                {group.providerName}
              </h3>
              <div className={css.variantsGrid} role="list">
                {group.items.map(v => (
                  <NamedLink
                    id="variantOtherStoreLink"
                    name="ListingPageCanonical"
                    params={{ id: v.listingId }}
                    key={v.id}
                    className={classNames(css.variantItem, {
                      [css.active]: v.listingId === listingId,
                    })}
                  >
                    {v.label}
                  </NamedLink>
                ))}
              </div>
            </section>
          ))}
        </div>
      )}
    </div>
  );
};

export default SectionVariantsMaybe;
